import { PlayerEnvironment } from './player_environment';
import createElement from './utils/create_element';
import BlockerButton from './service/blocker/button';
import { PlayerAhoyEvent } from './player_ahoy_event';
import VideoHelpers from './utils/video_helpers';
import TopicAdapter from './adapters/topic_adapter';
import FullscreenApiAdapter from './adapters/fullscreen_api_adapter';
export default class HdcpBlocker {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._blockerCountdown = 5 * 1000;
    this._started = false;
    this._blockerInterval = null;
    this._element = null;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  blockerCountdown() {
    return this._blockerCountdown;
  }

  started() {
    return this._started;
  }

  init() {
    this.setAhoyEventGlobalProperties();
    this.createBlockerRevamp();
    this.checkPlayability();
    this.onContentStart();
  }

  checkPlayability() {
    if (PlayerEnvironment.isMobileSite()) {
      this._blockerCountdown = 0;
      this.onContentBuffer();
    } else {
      this.onContentBuffer();
    }
  }

  onContentBuffer() {
    this.tech().one('bufferstart', () => {
      this.contentBufferHandler();
    });
  }

  contentBufferHandler() {
    if (this.started()) return;

    this._blockerInterval = setInterval(() => {
      this.removeInterval();
      this.showBlocker();
    }, this.blockerCountdown());
  }

  onContentStart() {
    this.tech().on('vp-start', () => {
      this._started = true;
      this.removeInterval();
    });
  }

  removeInterval() {
    clearInterval(this._blockerInterval);
    this._blockerInterval = null;
  }

  showBlocker() {
    this.tech().pause();

    this._element.classList.add('show');
    this.sendEvent();
  }

  sendEvent() {
    PlayerAhoyEvent.sendBlocker(
      this.data().type().toLowerCase(),
      this.data().isPremier(),
      this.data().videoId(),
      'hdcp'
    );
  }

  createBlockerRevamp() {
    const lang = VideoHelpers.getLang();
    const message = this.blockerContentRevamp(lang);
    this._element = createElement(`
      <div class="hdcp-blocker">
        <div class="hdcp-blocker__container">
          <h2 class="hdcp-blocker__title-revamp">${message.title}</h2>
          <div class="hdcp-blocker__subtitle-revamp">${message.subtitle}</div>
          <div class="hdcp-blocker__btn-container-revamp"></div>
        </div>
      </div>
    `);

    let container = this._element.querySelector(
      '.hdcp-blocker__btn-container-revamp'
    );
    container.appendChild(this.detailErrorButton(message.additionalCta));
    if (this._data.userIsPremier() || !this._data.isPremier()) {
      container.appendChild(this.exploreVidioButton(message.cta));
    } else {
      container.appendChild(this.activePackageButton(message.ctaNonPremiumUser));
    }
    this._element.appendChild(this.closeButton());

    this.tech().el().el().appendChild(this._element);
  }

  exploreVidioButton(text) {
    const vidioLink = 'https://www.vidio.com/';
    return BlockerButton.createRevamp('cta-revamp', text, null, {
      href: vidioLink,
    });
  }

  detailErrorButton(text) {
    const supportLink =
      'https://support.vidio.com/support/solutions/articles/43000642152-hdcp-information';
    return BlockerButton.createRevamp('additionalCta-revamp', text, null, {
      href: supportLink,
    });
  }

  activePackageButton(text) {
    const onClick = () => {
      FullscreenApiAdapter.exitFullscreen();
      this.tech().pause();
      TopicAdapter.publish('player/paymentblocker/show', {"source": "preview button"});
    }
    return BlockerButton.createRevamp('cta-revamp', text, onClick);
    
  }

  closeButton() {
    const element = document.createElement('button');
    element.className = 'hdcp-blocker__close';
    element.innerHTML = '&times;';
    element.onclick = this.onCloseButtonClick.bind(this);
    return element;
  }

  onCloseButtonClick() {
    this._element.classList.remove('show');
  }

  blockerContent(lang) {
    const message = {
      id: {
        title: 'Konten tidak bisa diputar',
        content:
          'Perangkatmu tidak mendukung HDCP. Gunakan perangkat lain untuk menonton konten ini',
        infoButton: 'Tentang HDCP',
        downloadButton: 'Download Aplikasi',
      },
      en: {
        title: "Content can't be played",
        content:
          'Your device does not support HDCP. Use another device to watch this content.',
        infoButton: 'About HDCP',
        downloadButton: 'Download App',
      },
    };

    return message[lang];
  }

  blockerContentRevamp(lang) {
    const message = {
      id: {
        title: 'Konten nggak bisa diputar',
        subtitle:
          'Perangkatmu nggak mendukung HDCP. Gunakan perangkat lain atau cari hiburan lainnya di Vidio yuk!',
        cta: 'Jelajahi Vidio',
        ctaNonPremiumUser: 'Aktifkan Paket',
        additionalCta: 'Detail Error',
      },
      en: {
        title: "This content can't be played",
        subtitle:
          "Your device doesn't support HDCP. Please use another device or browse around for more entertainment.",
        cta: 'Explore Vidio',
        ctaNonPremiumUser: 'Activate Package',
        additionalCta: 'Error Details',
      },
    };

    return message[lang];
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
